(() => {
  const SELECTOR = '[data-mojo-product-description-accordion]';
  const MOBILE_PERFORMANCE_QUERY = window.matchMedia('(max-width: 749px)');
  const MOBILE_MOTION_MS = 240;

  const replaceBrandText = (node) => {
    const walk = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walk.nextNode()) textNodes.push(walk.currentNode);

    textNodes.forEach((textNode) => {
      textNode.textContent = textNode.textContent.replace(/Mojo\s*Project/g, 'Mojo® Project');
    });

    return node;
  };

  const cleanNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const clone = node.cloneNode(true);
      clone.textContent = clone.textContent.replace(/Mojo\s*Project/g, 'Mojo® Project');
      return clone;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) return node.cloneNode(true);

    const clone = node.cloneNode(true);
    clone.removeAttribute('style');
    clone.removeAttribute('class');

    clone.querySelectorAll('[style], [class], font').forEach((element) => {
      if (element.tagName.toLowerCase() === 'font') {
        element.replaceWith(...element.childNodes);
        return;
      }

      element.removeAttribute('style');
      element.removeAttribute('class');
    });

    return replaceBrandText(clone);
  };

  const createHeadingNode = (title) => {
    const heading = document.createElement('h3');
    heading.textContent = title;
    return heading;
  };

  const hasRealContent = (nodes) => {
    return nodes.some((node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim() !== '';
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      return node.textContent.trim() !== '' || node.querySelector('img, video, iframe, svg, table');
    });
  };

  const unwrapSingleRootDiv = (root) => {
    const realChildren = Array.from(root.childNodes).filter((node) => {
      return node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== '';
    });

    if (
      realChildren.length === 1 &&
      realChildren[0].nodeType === Node.ELEMENT_NODE &&
      realChildren[0].tagName.toLowerCase() === 'div'
    ) {
      return realChildren[0];
    }

    return root;
  };

  const normalize = (value) => {
    return (value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  };

  const sectionType = (title) => {
    const text = normalize(title);

    if (/(kumas|doku|kalip|fit|materyal|material|gramaj|pamuk|fabric|texture|beden|size)/.test(text)) {
      return 'fitFabric';
    }

    if (/(kargo|teslimat|iade|shipping|delivery|return|support|destek)/.test(text)) {
      return 'shippingReturns';
    }

    if (/(felsefe|hikaye|marka|mojo|brand|soul|story|memory|hatira)/.test(text)) {
      return 'brandStory';
    }

    if (/(tasarim|detay|kombin|stil|grafik|baski|style|design|detail|print|nasil)/.test(text)) {
      return 'designDetails';
    }

    return 'designDetails';
  };

  const groupSections = (sections) => {
    const groups = [
      { key: 'fitFabric', title: 'Kalıp & Kumaş', sections: [] },
      { key: 'designDetails', title: 'Tasarım & Detaylar', sections: [] },
      { key: 'shippingReturns', title: 'Kargo & İade', sections: [] },
      { key: 'brandStory', title: 'Marka Felsefesi', sections: [] },
    ];

    sections.forEach((section) => {
      const type = sectionType(section.title);
      const group = groups.find((candidate) => candidate.key === type) || groups[1];
      group.sections.push(section);
    });

    return groups.filter((group) => group.sections.length > 0).slice(0, 4);
  };

  const createDescriptionModel = (source) => {
    const parser = document.createElement('div');
    parser.innerHTML = source.innerHTML.trim();

    const contentRoot = unwrapSingleRootDiv(parser);
    const nodes = Array.from(contentRoot.childNodes);
    let introNodes = [];
    const sections = [];
    let current = null;

    nodes.forEach((node) => {
      const isElement = node.nodeType === Node.ELEMENT_NODE;
      const tagName = isElement ? node.tagName.toLowerCase() : '';

      if (tagName === 'h3') {
        if (current && hasRealContent(current.nodes)) sections.push(current);
        current = {
          title: node.textContent.trim(),
          nodes: [],
        };
        return;
      }

      if (current) {
        current.nodes.push(cleanNode(node));
      } else {
        introNodes.push(cleanNode(node));
      }
    });

    if (current && hasRealContent(current.nodes)) sections.push(current);

    introNodes = introNodes.filter((node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim() !== '';
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'h2') return false;
      return true;
    });

    if (!sections.length && !hasRealContent(introNodes) && hasRealContent(nodes)) {
      introNodes = nodes.map(cleanNode);
    }

    return {
      introNodes,
      groups: groupSections(sections),
    };
  };

  const setAria = (item, open) => {
    const trigger = item.querySelector('.mojo-product-accordion__trigger');
    const panel = item.querySelector('.mojo-product-accordion__panel');
    if (!trigger || !panel) return;

    item.dataset.open = open ? 'true' : 'false';
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.toggleAttribute('inert', !open);
  };

  const lockPanelHeightsOnce = (target) => {
    if (MOBILE_PERFORMANCE_QUERY.matches || target.dataset.heightsLocked === 'true') return;

    target.querySelectorAll('.mojo-product-accordion__panel').forEach((panel) => {
      const content = panel.querySelector('.mojo-product-accordion__content');
      if (!content) return;

      panel.style.setProperty('--mojo-panel-height', `${Math.ceil(content.scrollHeight)}px`);
    });

    target.dataset.heightsLocked = 'true';
  };

  const scheduleHeightLockOnce = (target) => {
    window.requestAnimationFrame(() => lockPanelHeightsOnce(target));
  };

  const clearMobileMotionTimer = (item) => {
    if (!item._mojoAccordionMotionTimer) return;
    window.clearTimeout(item._mojoAccordionMotionTimer);
    item._mojoAccordionMotionTimer = null;
  };

  const setMobileAttributes = (item, open) => {
    const trigger = item.querySelector('.mojo-product-accordion__trigger');
    const panel = item.querySelector('.mojo-product-accordion__panel');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    panel.toggleAttribute('inert', !open);
  };

  const toggleItemMobile = (item, open) => {
    const isOpen = item.dataset.open === 'true';
    const isClosing = item.dataset.motion === 'closing';
    const isOpening = item.dataset.motion === 'opening';

    if (open && isOpen && !isClosing) return;
    if (!open && !isOpen && !isOpening) return;

    clearMobileMotionTimer(item);

    if (open) {
      item.dataset.motion = 'opening';
      item.dataset.open = 'false';
      setMobileAttributes(item, true);

      window.requestAnimationFrame(() => {
        item.dataset.open = 'true';
        item._mojoAccordionMotionTimer = window.setTimeout(() => {
          delete item.dataset.motion;
          item._mojoAccordionMotionTimer = null;
        }, MOBILE_MOTION_MS);
      });

      return;
    }

    item.dataset.motion = 'closing';
    setMobileAttributes(item, false);

    item._mojoAccordionMotionTimer = window.setTimeout(() => {
      item.dataset.open = 'false';
      delete item.dataset.motion;
      item._mojoAccordionMotionTimer = null;
    }, MOBILE_MOTION_MS);
  };

  const toggleItem = (item, open) => {
    if (MOBILE_PERFORMANCE_QUERY.matches) {
      toggleItemMobile(item, open);
      return;
    }

    const isOpen = item.dataset.open === 'true';
    if (isOpen === open) return;

    setAria(item, open);
  };

  const buildIntro = (nodes) => {
    const intro = document.createElement('div');
    intro.className = 'mojo-product-accordion__intro';
    nodes.forEach((node) => intro.appendChild(node));
    return intro;
  };

  const buildItem = (group, index, blockId) => {
    const item = document.createElement('div');
    const buttonId = `MojoAccordionTrigger-${blockId}-${index}`;
    const panelId = `MojoAccordionPanel-${blockId}-${index}`;

    item.className = 'mojo-product-accordion__item';
    item.dataset.open = 'false';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'mojo-product-accordion__trigger';
    trigger.id = buttonId;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panelId);

    const title = document.createElement('span');
    title.className = 'mojo-product-accordion__title';
    title.textContent = group.title;

    const icon = document.createElement('span');
    icon.className = 'mojo-product-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');

    trigger.append(title, icon);

    const panel = document.createElement('div');
    panel.className = 'mojo-product-accordion__panel';
    panel.id = panelId;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', buttonId);
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('inert', '');

    const content = document.createElement('div');
    content.className = 'mojo-product-accordion__content';

    group.sections.forEach((section) => {
      if (group.sections.length > 1 || normalize(section.title) !== normalize(group.title)) {
        content.appendChild(createHeadingNode(section.title));
      }

      section.nodes.forEach((node) => content.appendChild(node));
    });

    panel.appendChild(content);
    item.append(trigger, panel);

    return item;
  };

  const initAccordion = (accordion) => {
    if (accordion.dataset.initialized === 'true') return;

    const source = accordion.querySelector('.mojo-product-accordion__source');
    const target = accordion.querySelector('[data-accordion-items]');
    if (!source || !target || !source.innerHTML.trim()) return;

    const firstOpen = accordion.dataset.firstOpen === 'true';
    const allowMultiple = accordion.dataset.allowMultiple === 'true';
    const blockId = accordion.dataset.blockId || Math.random().toString(36).slice(2);
    const model = createDescriptionModel(source);

    // The source contains the full Shopify description. After building the lightweight
    // accordion DOM, remove it so mobile browsers do not keep duplicate hidden content
    // in the live page tree.
    source.remove();

    if (!hasRealContent(model.introNodes) && !model.groups.length) return;

    target.innerHTML = '';

    if (hasRealContent(model.introNodes)) {
      target.appendChild(buildIntro(model.introNodes));
    }

    model.groups.forEach((group, index) => {
      target.appendChild(buildItem(group, index, blockId));
    });

    scheduleHeightLockOnce(target);

    target.addEventListener('click', (event) => {
      const trigger = event.target.closest('.mojo-product-accordion__trigger');
      if (!trigger || !target.contains(trigger)) return;

      const item = trigger.closest('.mojo-product-accordion__item');
      if (!item) return;

      const shouldOpen = item.dataset.open !== 'true';

      if (!allowMultiple && shouldOpen) {
        target.querySelectorAll('.mojo-product-accordion__item[data-open="true"]').forEach((openItem) => {
          if (openItem !== item) toggleItem(openItem, false);
        });
      }

      toggleItem(item, shouldOpen);
    });

    if (firstOpen) {
      const firstItem = target.querySelector('.mojo-product-accordion__item');
      if (firstItem) setAria(firstItem, true);
    }

    accordion.dataset.initialized = 'true';
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initAccordion);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
